import { createContext } from 'react';
import { SmartReplyPromptPreset } from './smartReplyPromptTypes';

/**
 * Context for the smart reply prompts, which includes the prompt presets and a function to get a prompt by key
 */
export type SmartReplyContextData = Readonly<{
    prompts: SmartReplyPromptPreset[];
    getByKey: (key: string) => SmartReplyPromptPreset | undefined;
}>;

export const SmartReplyContext = createContext<SmartReplyContextData>({
    prompts: [],
    getByKey: () => undefined,
});
